import React from "react";
import Layout from './Layout';
import Dashboard from "../../components/User/Dashboard";

export const UserDashboardPage = () => <Layout><Dashboard /></Layout>
